/* ==========================================================================
   ELTANE — COMMUNITY / INSTAGRAM APP FALLBACK
   The Instagram feed app block (see eltane-community.liquid's `@app` block)
   renders its own error markup when it can't fetch posts — an account-status
   essay we don't want customers to see. Since that markup comes from the
   app, not this theme, we can't stop it being rendered; instead we watch the
   block for known error phrasing and swap in one quiet sentence. The block
   also stays silently empty when the app's own script never runs at all
   (blocked by an ad blocker / privacy extension, common on dev machines) —
   EMPTY_TIMEOUT_MS below catches that case too, rather than leaving a hole.
   ========================================================================== */
(function () {
  var EMPTY_TIMEOUT_MS = 8000;
  var OBSERVER_TIMEOUT_MS = 15000;

  var ERROR_SIGNS = [
    "couldn't retrieve",
    'could not retrieve',
    'currently unavailable',
    'wrong instagram account',
    'copyright restrictions',
    'try again later'
  ];

  function looksLikeAppError(text) {
    var lower = text.toLowerCase();
    return ERROR_SIGNS.some(function (needle) {
      return lower.indexOf(needle) !== -1;
    });
  }

  function applyFallback(container) {
    if (container.dataset.eltaneFallbackApplied === 'true') return;
    container.dataset.eltaneFallbackApplied = 'true';

    var message = container.dataset.eltaneFallbackText || "We'll be back in some time.";
    var fallback = document.createElement('div');
    fallback.className = 'eltane-community__app-fallback';

    var text = document.createElement('p');
    text.textContent = message;
    fallback.appendChild(text);

    container.innerHTML = '';
    container.appendChild(fallback);
  }

  function checkContainer(container) {
    if (container.dataset.eltaneFallbackApplied === 'true') return;
    var text = (container.textContent || '').trim();
    if (text.length > 0 && looksLikeAppError(text)) {
      applyFallback(container);
    }
  }

  function checkEmpty(container) {
    if (container.dataset.eltaneFallbackApplied === 'true') return;
    var hasMedia = container.querySelector('img, iframe, video, picture');
    var text = (container.textContent || '').trim();
    if (!hasMedia && text.length === 0) {
      applyFallback(container);
    }
  }

  function watch(container) {
    checkContainer(container);

    var observer = new MutationObserver(function () {
      checkContainer(container);
    });
    observer.observe(container, { childList: true, subtree: true, characterData: true });

    setTimeout(function () {
      checkEmpty(container);
    }, EMPTY_TIMEOUT_MS);

    setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);
  }

  function init() {
    document.querySelectorAll('[data-eltane-instagram-app]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
